import { VisualisationType } from 'store/reducers/visualisations/types';

export const defaultVisualisationWithActiveIncisionId = ['pie', 'lineAndBar', 'waterfall', 'bubble'];

export const visualisationTypes: VisualisationType[] = ['tree', 'pie', 'lineAndBar', 'waterfall', 'bubble', 'heatmap', 'table'];

export const trackerSection = 'tracker-section';

export const withRightAndLeftBar = 116;
